export const localesCatalog: Record<
  string,
  { language: string; code: string }
> = {
    'en-US': {
        language: 'English',
        code: 'en-US',
    },
    'es-DO': {
        language: 'Spanish',
        code: 'es-DO',
    },
};
